export * from './template';
export * from './utils';

import * as Common from './common';
import * as Template from './template';

const components = {
  ...Common,
  ...Template,
};

function install(app) {
  Object.entries(components).forEach(([name, comp]) => {
    app.component(name, comp);
  });
}

export default { install };
